/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Selection } from './Selection';
import {
    SelectionFromJSON,
    SelectionFromJSONTyped,
    SelectionToJSON,
    SelectionToJSONTyped,
} from './Selection';
import type { Model } from './Model';
import {
    ModelFromJSON,
    ModelFromJSONTyped,
    ModelToJSON,
    ModelToJSONTyped,
} from './Model';

/**
 * 
 * @export
 * @interface Selections
 */
export interface Selections {
    /**
     * 
     * @type {number}
     * @memberof Selections
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Selections
     */
    name: string;
    /**
     * 
     * @type {Model}
     * @memberof Selections
     */
    modelId: Model;
    /**
     * 
     * @type {Array<Selection>}
     * @memberof Selections
     */
    selectionIds: Array<Selection>;
}

/**
 * Check if a given object implements the Selections interface.
 */
export function instanceOfSelections(value: object): value is Selections {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('modelId' in value) || value['modelId'] === undefined) return false;
    if (!('selectionIds' in value) || value['selectionIds'] === undefined) return false;
    return true;
}

export function SelectionsFromJSON(json: any): Selections {
    return SelectionsFromJSONTyped(json, false);
}

export function SelectionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Selections {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'modelId': ModelFromJSON(json['model_id']),
        'selectionIds': ((json['selection_ids'] as Array<any>).map(SelectionFromJSON)),
    };
}

export function SelectionsToJSON(json: any): Selections {
    return SelectionsToJSONTyped(json, false);
}

export function SelectionsToJSONTyped(value?: Selections | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'model_id': ModelToJSON(value['modelId']),
        'selection_ids': ((value['selectionIds'] as Array<any>).map(SelectionToJSON)),
    };
}

